__turbopack_context__.v({
  "dot": "uk-dot-map-module__vyQ_cq__dot",
  "dot-in": "uk-dot-map-module__vyQ_cq__dot-in",
});
